import React from 'react';
import cx from 'classnames';

interface BreadcrumbsProps {
    context: GapAnalysisContext;
}

/**
 * Shows a list of the title for each step in the process of creating a Gap Analysis report. Each
 * step.title can be changed during the process so that it can go from an action (step.defaultTitle)
 * like "Select Period" to a value (step.title) like "2020 Q4".
 * @param props - {@link BreadcrumbsProps}
 * @returns JSX
 */
export const Breadcrumbs = ({ context }: BreadcrumbsProps): JSX.Element => {
    const { steps, stepHistory } = context;

    const breadcrumbSteps = stepHistory.map(
        (stepId: GapAnalysisStepId): GapAnalysisStep => steps[stepId],
    );

    return (
        // This width value keeps the breadcrumbs from overlapping the global search input
        <div className="truncate flex" style={{ width: 580 }}>
            {breadcrumbSteps.map(
                (step: GapAnalysisStep, index: number): JSX.Element[] => {
                    const result = [
                        <div
                            className={cx('truncate', {
                                'font-semibold': step.title !== null,
                            })}
                            key={step.id}
                            style={{ maxWidth: 400 }}
                        >
                            {step.title ?? step.defaultTitle}
                        </div>,
                    ];

                    if (index < breadcrumbSteps.length - 1) {
                        result.push(
                            <div className="mx-1" key={`${step.id}-slash`}>
                                /
                            </div>,
                        );
                    }

                    return result;
                },
            )}
        </div>
    );
};
